module.exports = __webpack_public_path__ + "img/outlook-calendar.c74eb9f4.svg";